import type { I18nFn } from 'i18n/types/I18nFn';

export function LISTING_TYPE_PLURAL_HUMAN_NAME_MAP(i18n: I18nFn) {
  return {
    JOB: i18n('jobs'),
    INTERNSHIP: i18n('internships'),
    VOLOP: i18n('volunteer opportunities'),
    ORG: i18n('organizations'),
    EVENT: i18n('events'),
    IMPORTED: i18n('opportunities'),
  };
}

export const LISTING_TYPE_PLURAL_HUMAN_TRACKING_NAME_MAP = {
  JOB: 'jobs',
  INTERNSHIP: 'internships',
  VOLOP: 'volunteer opportunities',
  ORG: 'organizations',
  EVENT: 'events',
  IMPORTED: 'opportunities',
};
